(function () {

  'use strict';

  /**
   * @author Chester Rivas | Zain Syed
   * @description extends Bootstrap's modal directive
   * @class ute-ui
   * @memberOf ute-ui
   */
  angular.module('ute.ui')

    .factory('uteModal', ["$modal", "$q", "$timeout", function ($modal, $q, $timeout) {

      var modalInstance;

      /**
       * @name uteModal
       * @type {Object}
       */
      var uteModal = {};

      /**
       * @property uteModal.config
       * @type {Object}
       * @description object containing default controller variables
       */
      uteModal.config = {};

      /**
       * @property uteModal.controllerScope
       * @type {Object}
       * @description
       */
      uteModal.controllerScope = null;

      /**
       * @property uteModal.defaultController
       * @type {Function}
       * @description if no controller is specified by @open then this controller is used to display the modal
       */
      uteModal.defaultController = /*@ngInject*/ ["$scope", "$modalInstance", function ($scope, $modalInstance) {

        uteModal.controllerScope = $scope;

        $scope.title = angular.isDefined(uteModal.config) && angular.isDefined(uteModal.config.title) ? uteModal.config.title : 'Confirm';

        $scope.message = angular.isDefined(uteModal.config) && angular.isDefined(uteModal.config.message) ? uteModal.config.message : 'Please confirm';

        $scope.okButtonLabel = angular.isDefined(uteModal.config) && angular.isDefined(uteModal.config.okButtonLabel) ? uteModal.config.okButtonLabel : 'Continue';

        $scope.cancelButtonLabel = angular.isDefined(uteModal.config) && angular.isDefined(uteModal.config.cancelButtonLabel) ? uteModal.config.cancelButtonLabel : 'Cancel';

        $scope.ok = function () {
          $modalInstance.close();
          uteModal.closeThisModal($modalInstance);
        };

        $scope.cancel = function () {
          $modalInstance.dismiss('cancel');
          uteModal.closeThisModal($modalInstance);
        };

        return {
          $scope: $scope,
          $modalInstance: $modalInstance
        };

      }];

      /**
       * @property uteModal.closeThisModal
       * @type {Function}
       * @description closes a specific modal
       */
      uteModal.closeThisModal = function (modal) {

        if (angular.isUndefinedOrNull(modal)) {

          modalInstance.dismiss('cancel');

        } else {

          _.each(uteModal.modalInstancesArray, function (eachModal, index) {
            if (angular.equals(modal, eachModal)) {
              uteModal.modalInstancesArray.splice(index, 1);
            }
          });

        }

      };

      /**
       * @property uteModal.closeAllModals
       * @type {Function}
       * @description loops through all open modal instance and closes it
       */
      uteModal.closeAllModals = function () {

        _.each(uteModal.modalInstancesArray, function (eachModal) {
          eachModal.dismiss('cancel');
        });

        uteModal.modalInstancesArray = [];

      };

      /**
       * @property uteModal.modalInstancesArray
       * @type {Array}
       * @description holds an instance of all open modals
       */
      uteModal.modalInstancesArray = [];

      /**
       * @property uteModal.processRequest
       * @type {function}
       * @description process modal - restricts the user from closing it; the user has to cancel, which would cancel the ajax request and close the modal
       */
      uteModal.processRequest = function (config) {

        // return a deferred object's promise at the end of this method
        var deferred = $q.defer();

        $modal.open({
          templateUrl: 'uteModal/processing-request.html',
          backdrop: 'static',
          resolve: {
            def: function () {
              return deferred;
            }
          },
          controller:  ['$scope', '$http', '$modalInstance', 'def', '$timeout',function ($scope, $http, $modalInstance, def, $timeout) {

            /* The modal behaviour is segmented into 3 parts:
             *  1) Occurs from 0-10s - the user should see the 'loading' icon (roadblocker).
             *  2) Occurs from 10-30s - the user should see the 'processing' copy (non-roadblocker).
             *  3) If the SS returns an error or times out, show the error message.
             */

            var loadingDuration = config.delay ? config.delay : 10000;

            // the cancel method should kill the ajax call and close the modal
            $scope.cancel = function () {
              $modalInstance.close();
              $timeout.cancel($scope.loadingSegment);
              def.reject('Cancelled');
            };

            // make requested ajax call
            $scope.makeRequest = function () {

              // bind the promise to request so we can cancel it if the option is provided
              config.request.timeout = def.promise;

              // show loading segment information
              $scope.loadingView = true;
              $scope.processingView = false;
              $scope.errorView = false;

              // timers
              $scope.loadingSegment = $timeout(function () {
                // noop
              }, loadingDuration);

              // behaviour for success/failures of the timers
              $scope.loadingSegment.then(function () {
                // completed loadingDuration -- show next segment
                $scope.loadingView = false;
                $scope.processingView = true;
                $scope.errorView = false;

              }, function () {
                // noop
              });

              // make the ajax call
              $http(config.request).
              success(function (data, status) {
                def.resolve(data);
                $modalInstance.close();
                $timeout.cancel($scope.loadingSegment);
              }).
              error(function (data, status) {
                if (config.request.closeOnError && config.request.closeOnError === true){
                  $scope.cancel();
                } else {
                  $scope.loadingView = false;
                  $scope.processingView = false;
                  $scope.errorView = true;
                  $timeout.cancel($scope.loadingSegment);
                }
              });
            };

            // kick off!
            $scope.makeRequest();

          }]

        });

        uteModal.config = config;

        return deferred.promise;

      };

      /**
       * @type {Object}
       * @description contains a default object
       * @property uteModal.defaultConfigObject
       * @type {{backdrop: boolean, cp: boolean, templateUrl: boolean, controller: boolean, ok: boolean, cancel: boolean, opened: boolean, size: boolean, keyboard: boolean}}
       */
      uteModal.defaultConfigObject = {
        backdrop: true,
        cp: false,
        title: '',
        inheritScope: false,
        templateUrl: 'uteModal/modal.html',
        controller: uteModal.defaultController,
        ok: null,
        okButtonLabel: 'Continue',
        cancel: null,
        cancelButtonLabel: 'Cancel',
        opened: null,
        size: 'md',
        keyboard: true
      };

      /**
       * @type {Function}
       * @description opens a modal with a custom view and ctrl has callback for ok and cancel clicks
       * @property uteModal.open
       * @param config {object}
       * @property {object} config.backdrop {boolean} - whether to show the backdrop behind the modal
       * @property {object} config.cp {boolean} - whether the modal is a canada post modal which requires dom manipulation logic
       * @property {object} config.templateUrl {string} - path to a view
       * @property {object} config.controller {function} - controller for that modal
       * @property {object} config.ok {function}
       * @property {object} config.cancel {function}
       * @property {object} config.size {string}
       * @property {object} config.keyboard {boolean}
       * @property {object} config.title {string} - friendly name for tracking in dtm
       */
      uteModal.open = function (config) {

        var modalConfig = _.defaults({}, config ? config : {}, uteModal.defaultConfigObject),
          filteredResolveObj = {};

        if (angular.isDefined(modalConfig.resolve)) {
          // if config param contains a resolve object property that contains sub properties then loop through that
          _.each(modalConfig.resolve, uteModal.loopResolveFunction.bind(uteModal, filteredResolveObj));
        } else {
          // else loop through the entire config object to pick up any properties that should be passed into the controller
          _.each(config, uteModal.loopResolveFunction.bind(uteModal, filteredResolveObj));
        }

        // if tempResolve object is empty then don't define that property
        if (_.keys(filteredResolveObj).length) modalConfig.resolve = filteredResolveObj;

        // save last config to the service for referencing in default controller
        uteModal.config = modalConfig;

        modalInstance = $modal.open(uteModal.config);

        uteModal.modalInstancesArray.push(modalInstance);

        if (uteModal.config.cp) {
          // close
          var cleanUpCanadaPost = function () {
            $('.pca:first').insertAfter($('ute-footer'));
            $('.pca:first').removeClass('formodal');
          };
          modalInstance.result.then(cleanUpCanadaPost, cleanUpCanadaPost);
        }

        if (uteModal.config.ok && uteModal.config.cancel) {
          modalInstance.result.then(config.ok, config.cancel);
        }

        // do something on opened promise
        modalInstance.opened
          .then(function () {

            // try immediately to focus
            $('.modal-content').find('input[type="text"]:first').focus();

            // try after 1 second to focus
            $timeout(function () {
              $('.modal-content').find('input[type="text"]:first').focus();
            }, 1000);

          });

        modalInstance.opened
          .then(uteModal.config.opened, function () {
            console.warn('uteModal: open failed');
          });

        return modalInstance;

      };

      /**
       * @property uteModal.isNotDefaultProperty
       * @type {Function}
       * @description checks to see if passed in key exists on the uteModal.config object
       * @param key
       * @returns {boolean}
       */
      uteModal.isNotDefaultProperty = function (key) {
        return !angular.isDefined(uteModal.defaultConfigObject[key]);
      };

      /**
       * @property uteModal.loopResolveFunction
       * @type {Function}
       * @description loops through an object and ignores certain properties
       * @param tempResolve - object which will be built up through the loop function
       * @param subObject - sub object within the loop
       * @param subKey - the sub key
       */
      uteModal.loopResolveFunction = function (tempResolve, subObject, subKey) {

        // ignore any key that is a default property of config object
        if (uteModal.isNotDefaultProperty(subKey)) {

          if (typeof subObject === 'function' && typeof subObject() === 'undefined') {
            // if subObject is type of function
            // and subObject() returns you something that's not undefined
            tempResolve[subKey] = subObject;
          } else {
            // else take each property and turn it into a "getter" function
            tempResolve[subKey] = function () {
              return subObject;
            };
          }
        }

        return tempResolve;

      };

      return uteModal;

    }]);

})();
